import React from 'react';
import PageHero from '../components/PageHero';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { industries } from '../data/mock';
import { CheckCircle2, Factory, Cog, TrendingUp, Shield } from 'lucide-react';
import { Helmet } from "react-helmet";


const IndustrialPage = () => {
  const industry = industries[1]; // Industrial Manufacturing Partnerships
  
  const breadcrumbItems = [
    { label: 'HOME', path: '/' },
    { label: 'INDUSTRIAL' }
  ];

  return (
    <div className="page-wrapper">
      <PageHero 
        title="Industrial Manufacturing Partnerships"
        breadcrumbItems={breadcrumbItems}
        subtitle="Reliable manufacturing support for industrial clients"
      />
      
      <section className="page-content-section">
        <div className="container-modern">
          <div className="industry-detail-layout">
            <div className="industry-detail-hero">
              <img src={industry.image} alt={industry.title} />
              <div className="industry-detail-overlay"></div>
            </div>
            
            <div className="industry-detail-content">
              <div className="industry-intro">
                <h2 className="industry-detail-title">{industry.description}</h2>
                <p className="industry-tagline-large">{industry.tagline}</p>
              </div>
              
              <div className="features-grid">
                <div className="feature-detail-card">
                  <Factory className="feature-detail-icon" />
                  <h3>Production-Grade Parts</h3>
                  <p>Industrial-strength components built to withstand demanding production environments.</p>
                </div>
                
                <div className="feature-detail-card">
                  <Cog className="feature-detail-icon" />
                  <h3>Repeatable Tolerances</h3>
                  <p>Consistent dimensional accuracy across batches with strict quality control.</p>
                </div>
                
                <div className="feature-detail-card">
                  <TrendingUp className="feature-detail-icon" />
                  <h3>Long-Term Supply</h3>
                  <p>Reliable manufacturing partnership for ongoing production and supply needs.</p>
                </div>
                
                <div className="feature-detail-card">
                  <Shield className="feature-detail-icon" />
                  <h3>Process-Driven Execution</h3>
                  <p>Documented workflows and quality assurance for industrial compliance.</p>
                </div>
              </div>
              
              <div className="capabilities-section">
                <h3 className="section-subtitle">Core Capabilities</h3>
                <ul className="capabilities-list">
                  {industry.features.map((feature, idx) => (
                    <li key={idx}>
                      <CheckCircle2 className="capability-check" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="process-overview">
                <h3 className="section-subtitle">Manufacturing Excellence</h3>
                <p className="process-text">
                  Our industrial manufacturing services are designed for factories, OEM suppliers, and production environments that demand precision, consistency, and reliability. We maintain strict tolerances, documented processes, and quality control measures that meet industrial standards.
                </p>
              </div>
              
              <div className="industries-served">
                <h3 className="section-subtitle">Industries We Serve</h3>
                <div className="industries-tags">
                  <span className="industry-tag">Automotive</span>
                  <span className="industry-tag">Aerospace</span>
                  <span className="industry-tag">Medical Devices</span>
                  <span className="industry-tag">Industrial Equipment</span>
                  <span className="industry-tag">Consumer Products</span>
                  <span className="industry-tag">Electronics</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <ContactForm />
      <Footer />
    </div>
  );
};

export default IndustrialPage;
